import React from 'react';
import Moment from 'moment';
import {
  DragSourceAndDropTarget,
  DragAndDropSpace,
} from '../../components/DnDWrapper';
import Tippy from '../../components/ReactTippy';
import { isApiFlagOn } from '../../utilities/commonUtil';

export const JobContents = ({
  jobs,
  values,
  errors,
  isSettingId,
  callbacks,
  canDrag,
  roleId,
  infinityScrollLoad,
}) => {
  const DndSpace = element => {
    return <DragAndDropSpace>{element}</DragAndDropSpace>;
  };

  return DndSpace(
    <div className='master-slide-view__body'>
      <div className='constructionlist__list'>
        <table className='table table--constructionlist__list'>
          <thead className='table__header'>
            <tr className='table__label'>
              {canDrag && (
                <td className='value-table value-table--table__label'>
                  <div className='value-table__label' />
                </td>
              )}
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>職種名</div>
              </td>
              <td className='value-table  value-table--table__label'>
                <div className='value-table__label'>職種名ふりがな</div>
              </td>
              <td className='value-table  value-table--table__label'>
                <div className='value-table__label'>登録日</div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>更新日</div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>ステータス</div>
              </td>
              <td
                className='value-table value-table--table__label'
                style={{ display: roleId < 3 ? '' : 'none' }}
              >
                <div className='value-table__label' />
              </td>
            </tr>
          </thead>
          <tbody>
            {isSettingId === 0 ? (
              <JobRegister
                key={0}
                values={values}
                errors={errors}
                callbacks={callbacks}
              />
            ) : null}
            {jobs.map((job, index) => {
              return isSettingId === job.id ? (
                <JobRegister
                  key={job.id}
                  values={values}
                  errors={errors}
                  callbacks={callbacks}
                />
              ) : (
                <Job
                  key={index}
                  index={index}
                  job={job}
                  callbacks={callbacks}
                  canDrag={canDrag}
                  roleId={roleId}
                />
              );
            })}
            {}
          </tbody>
        </table>
        {infinityScrollLoad}
      </div>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const getStatus = (job, onChangeStatus) => {
  if (job.display_flag === 1) {
    return <span className='setting-status-using'>使用中</span>;
  }
  return <span className='setting-status'>未使用</span>;
};

export const Job = ({ job, callbacks, canDrag, index, roleId }) => {
  const DndSrcTgt = element => {
    if (canDrag) {
      return (
        <DragSourceAndDropTarget
          id={`gateDnD`}
          index={index}
          data={job}
          onHover={callbacks.dnd.onHover.bind(this)}
          onBeginDrag={callbacks.dnd.onBeginDrag.bind(this)}
          onDropped={callbacks.dnd.onDropped.bind(this)}
          canDrag={true}
          canDrop={true}
        >
          {element}
        </DragSourceAndDropTarget>
      );
    }

    return element;
  };

  const tooltipStyle = {
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
    color: 'white',
    maxWidth: '400px',
    wordWrap: 'break-word',
  };

  return DndSrcTgt(
    <tr className='table__item' key={job.id}>
      {canDrag && (
        <td className='gate-list-value-table__drag'>
          <button
            className='btn-icon--sm'
            style={{
              display: isApiFlagOn(job.display_flag) ? 'inline-block' : 'none',
            }}
          >
            <i className='i-drag i-3x' />
          </button>
        </td>
      )}
      <td className='gate-list-value-table__name'>
        <span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={<div style={tooltipStyle}>{job.name}</div>}
          >
            <p>{job.name}</p>
          </Tippy>
        </span>
      </td>
      <td className='gate-list-value-table__name'>
        <span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={<div style={tooltipStyle}>{job.kana}</div>}
          >
            <p>{job.kana}</p>
          </Tippy>
        </span>
      </td>
      <td className='gate-list-value-table__date'>
        <span className='label'>登録日時</span>
        <p className='date-long'>
          <span className='date-long__date'>
            {Moment(job.created_at).format('YYYY/MM/DD')}
          </span>
          <span className='date-long__time'>
            {Moment(job.created_at).format('HH:mm')}
          </span>
        </p>
      </td>
      <td className='gate-list-value-table__date'>
        <span className='label'>更新日時</span>
        <p className='date-long'>
          <span className='date-long__date'>
            {Moment(job.updated_at).format('YYYY/MM/DD')}
          </span>
          <span className='date-long__time'>
            {Moment(job.updated_at).format('HH:mm')}
          </span>
        </p>
      </td>
      <td className='gate-list-value-table__status'>{getStatus(job)}</td>
      <td
        className='gate-list-value-table__menu'
        style={{ display: roleId < 3 ? '' : 'none' }}
      >
        <div className='setting-edit-btn'>
          <button
            className='btn--sm--stay'
            onClick={() => callbacks.form.setFormValues(job)}
            style={{ display: canDrag ? 'none' : 'inline-block' }}
          >
            編集
          </button>
        </div>
      </td>
    </tr>
  );
};

const getErrorMessaage = (errors, column) => {
  if (errors[column]) {
    return <div className='validate-message show'>{errors[column]}</div>;
  } else {
    return null;
  }
};

export const JobRegister = ({ values, errors, callbacks }) => (
  <tr className='table__item editable'>
    <td className='gate-list-value-table__name'>
      <span className='label'>職種名</span>
      <input
        type='text'
        name='name'
        className='--col-xs-10 --col-md-10 --col-lg-10 --col-xl-10'
        value={values.name}
        onChange={e => callbacks.form.set(e)}
        onBlur={e => callbacks.form.validate(e)} // バリデーション
      />
      {getErrorMessaage(errors, 'name')}
    </td>
    <td className='gate-list-value-table__name'>
      <span className='label'>職種名ふりがな</span>
      <input
        type='text'
        name='kana'
        className='--col-xs-10 --col-md-10 --col-lg-10 --col-xl-10'
        value={values.kana}
        onChange={e => callbacks.form.set(e)}
        onBlur={e => callbacks.form.validate(e)} // バリデーション
      />
      {getErrorMessaage(errors, 'kana')}
    </td>
    <td className='gate-list-value-table__size'>
      <span className='label'>登録日</span>
    </td>
    <td className='gate-list-value-table__size'>
      <span className='label'>更新日</span>
    </td>
    <td className='gate-list-value-table__size'>
      <span className='label'>ステータス</span>
      {values.id ? (
        <select
          name='display_flag'
          value={values.display_flag}
          onChange={e => callbacks.form.set(e)}
        >
          <option value='1'>使用中</option>
          <option value='0'>未使用</option>
        </select>
      ) : null}
    </td>
    <td className='gate-list-value-table__menu'>
      <ul className='setting-edit-menu'>
        {values.id ? (
          <li className='setting-edit-menu__item'>
            <button
              className='btn--sm--negative'
              onClick={() => callbacks.modal.deleteModal(values.id, callbacks)}
            >
              削除
            </button>
          </li>
        ) : null}
        <li className='setting-edit-menu__item'>
          <button
            className='btn--sm--sub'
            onClick={callbacks.form.clearFormValues}
          >
            戻る
          </button>
        </li>
        <li className='setting-edit-menu__item'>
          <button
            className='btn--sm--effective'
            type='submit'
            disabled=''
            onClick={() => callbacks.form.submit()}
          >
            保存
          </button>
        </li>
      </ul>
    </td>
  </tr>
);



// WEBPACK FOOTER //
// ./src/components/tables/Job.jsx